<template>
  <div>
    <div class="left-side m-n" v-if="!empty">
      <div class="page-header m-t-0 m-b-sm b-n">
        <h1 class="m-n text-u-c">Products</h1>
        <div class="viewAll" v-if="views" @click="viewAll()">view all</div>
      </div>
      <div>
        <div @click="gotoProduct(product.id)" class="product-b" v-for="product of products">
          <div v-if="product.labels.find(label => label.type === 1)" class="special-btn">special</div>
          <div v-if="product.labels.find(label => label.type === 2)" class="clearance-btn">clearance</div>
          <img v-if="product.primaryImage" :src="product.primaryImage.url">
          <div class="left-product-block-name">{{product.name}}</div>
          <div class="left-product-block-brand">{{product.brand}}</div>
          <div class="left-product-prices">
            <div class="left-product-current-price" v-if="product.price">
              RM {{priceFormat(product.discount_price ? product.discount_price : product.price)}}
              <span class="product-unit">{{product.unit_of_measure ? '/' + product.unit_of_measure : ''}}</span>
            </div>
            <div class="left-product-old-price" v-if="product.discount_price">
              <span class="product-old-price-number">RM {{priceFormat(product.price)}}</span>
              <span>({{calcOffDiscount(product.price, product.discount_price)}}
                % off)</span>
            </div>
          </div>
        </div>
        <div v-if="loader">
          <pre-loader></pre-loader>
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>

import product from '../products/product';
import ApiService from "../../../../services/ApiService";

export default {
  components: {
    product
  },
  data() {
    return {
      loader: false,
      marketplaceService: new ApiService(window.marketplace.apiUrl, null, false),
      empty: false,
      views: false,
      products: [],
      perPage: 3,
      page: 1,
      win: {
        w: null,
        h: null
      }
    }
  },
  created() {
    // window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    // window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    products: function(to) {
      this.products = to;
    }
  },
  computed:{
    profile(){
      return this.$store.getters.profile;
    }
  },
  methods: {
    handleResize() {
      this.win.w = window.innerWidth;
      this.win.h = window.innerHeight;
      if(this.win.w >= 1200){
        this.perPage = 3;
        this.getProducts(this.profile.profile_id);
      }
      if(this.win.w >= 1024 && this.win.w < 1200){
        this.perPage = 3;
        this.getProducts(this.profile.profile_id);
      }
      if(this.win.w >= 768 && this.win.w < 1024){
        this.perPage = 3;
        this.getProducts(this.profile.profile_id);
      }
      if(this.win.w < 768){
        this.perPage = 6;
        this.getProducts(this.profile.profile_id);
      }
    },
    getProducts(profile_id = null) {
      this.loader = true;
      if(profile_id) {
        this.marketplaceService.get(`/products?store_id=${window.marketplace.store_id}&user_id=${this.profile.profile_id}&status[]=10&status[]=70&page=${this.page}&per-page=${this.perPage}`)
          .then(res => {
            this.empty = res.meta.total == 0;
            if(this.empty) this.getProducts();
            else {
              this.products = res.products;
              this.views = res.meta.last_page !== res.meta.current_page;
              this.loader = false;
            }
          })
      } else {
        this.marketplaceService.get(`/products?store_id=${window.marketplace.store_id}&status[]=10&status[]=70&page=${this.page}&per-page=${this.perPage}`)
          .then(res => {
            this.empty = res.meta.total === 0;
            this.products = res.products;
            this.views = res.meta.last_page !== res.meta.current_page;
            this.loader = false;
          })
      }

    },
    calcOffDiscount(price, discount_price) {
      return 100 - Math.round((discount_price / price) * 100);
    },
    priceFormat(price) {
      return price.toLocaleString('en', { minimumFractionDigits: 2 });
    },
    gotoProduct(id) {
      window.location.assign('/ukuya/default/product#/' + id);
    },
    viewAll() {
      this.$router.push('products');
    }
  }
}
</script>

<style lang="scss">
  .lazy-image-placeholder {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .primary-image .lazy-img {
    max-width: 100%;
  }
  .products-grids {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .product-b {
    display: block;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 10px;
    width: 100%;
    max-width: 222px;
    background-color: #fff;
    cursor: pointer;
    transition: all .2s;
    &:hover {
      box-shadow: 0 5px 10px rgba(0,0,0,.1);
    }
  }
  .product-b img {
    margin: 7% 10%;
    width: 80%;
  }
  .left-product-block-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: #000;
  }
  .left-product-block-brand {
    color: #888;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .left-product-prices {
    padding: 0;
    min-height: 20px;
  }
  .left-product-current-price {
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    color: #000;
  }
  .product-unit {
    font-weight: normal;
    font-size: .8rem;
    color: #888;
  }
  .left-product-old-price {
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    color: #888;
  }
  .product-old-price-number {
    text-decoration: line-through;
  }
  .left-side {
    margin-top: 0 !important;
    margin-bottom: 35px !important;
  }
  .page-header {
    margin-top: 17px;
    margin-bottom: 0;
    color: #000;
  }
  .page-header h1 {
    font-style: normal;
    font-weight: 300 !important;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.72px;
  }
  .viewAll {
    cursor: pointer;
    font-size: 12px;
    line-height: 14px;
    color: #555;
  }
  .special-btn {
    display: block;
    position: relative;
    margin-bottom: -30px;
    background: #FF0221;
    border-radius: 0;
    font-weight: bold;
    font-size: 12px;
    text-align: center;
    color: #FFFFFF;
    width: 81px;
    text-transform: uppercase;
    float: right;
    margin-right: -10px;
    z-index: 999999;
  }
  .clearance-btn {
    display: block;
    position: relative;
    margin-bottom: -30px;
    background: #FF8002;
    border-radius: 0;
    font-weight: bold;
    font-size: 12px;
    padding-right: 5px;
    text-align: center;
    letter-spacing: 0.36px;
    color: #FFFFFF;
    width: 81px;
    text-transform: uppercase;
    float: right;
    margin-right: -10px;
    z-index: 999999;
  }
  @media only screen and (max-width: 1200px) and (min-width: 1024px) {
  }
  @media only screen and (max-width: 1023px) and (min-width: 768px) {
  }
  @media only screen and (max-width: 767px) {
  }
</style>
